export enum WorkerInMessageType {
  StartRefreshTokenTimer = 'startRefreshTokenTimer',
  StartPingInterval = 'startPingInterval',
  StopPingInterval = 'stopPingInterval',
  SchedulePongTimeout = 'schedulePongTimeout',
  ClearPongTimeout = 'clearPongTimeout',
}

export enum WorkerOutMessageType {
  RenewToken = 'renewToken',
  PingTick = 'pingTick',
  PongTimeout = 'pongTimeout',
}
